(function() {

    'use strict';

    angular.module('Services').factory('ManifestsTableService', ManifestsTableService);

    ManifestsTableService.$inject = [
        'ManifestService', 
        'TableLiteFactory', 
        'CommonService', 
        'Shipments', 
        '$filter', 
        'ManifestViewShipmentFactory',
        'Carrier',
        '$q',
        'ClientService'
    ];

    function ManifestsTableService(
        ManifestService, 
        TableLiteFactory, 
        CommonService, 
        Shipments, 
        $filter, 
        ManifestViewShipmentFactory,
        Carrier,
        $q,
        ClientService
    ) {

        return function (serviceDetailsList) {
            var manifestTable = {
                tableName: 'ManifestsTableService',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    "label": "MANIFEST DATE",
                    "viewName": "createdDateFormatted",
                    "filterName": "createdDate",
                    "filter": {
                        type: 'datePicker',
                        toModel: '',
                        fromModel: '',
                        useArray: true,
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    "label": "MANIFEST NO.",
                    "viewName": "manifestNumber",
                    "filterName": "manifestNumber",
                    "filter": {
                        "type": "text",
                        "placeholder": "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    "label": "COMPANY",
                    "viewName": "companyName",
                    "filterName": "companyId",
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            ClientService.Company.getAll(res => {
                                this.items = res.content;
                                defer.resolve();
                            }, error => {
                                console.log(error);
                                defer.reject();
                            }, {name: model});
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    "label": "OFFICE / LOCATION",
                    "viewName": "officeName",
                    "filterName": "officeName",
                    "filter": {
                        "type": "text",
                        "placeholder": "Search",
                        onSubmit: header=>{
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },/* {
                    label: 'Linked Job',
                    viewName: 'jobId',
                    filterName: 'job.id',
                    filter: {
                        type: 'text',
                        class: 'filter-customer-ref',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, */{
                    label: 'CARRIER PROFILE',
                    viewName: 'carrierProfileName',
                    filterName: 'carrierProfileId',
                    sortName: 'carrierProfile.id',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.getExternalCarrierProfiles((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                defer.resolve();
                            }, (error) => {
                                console.log(error);
                                defer.reject();
                            }, {size: 10, name: model});
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'SERVICE PROFILE',
                    viewName: 'serviceProfileName',//to fix
                    filterName: 'serviceProfileId',//to fix
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'displayName',
                        filterBy: 'id',
                        items: [], //List of items shown in dropdown
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.getServiceProfiles((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, {
                                size: 10,
                                name: model,
                                carrierProfileId: tableActions.activeFilters.carrierProfileId
                            });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    "label": "NO. OF SHIPMENTS",
                    "viewName" : "shipmentsCount",
                    "filterName": "shipmentsCount",
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                /*    "label": "SERVICE",
                    "viewName": "service",
                    "filterName": "serviceDetails.serviceId",
                    "filter": {
                        "type": "select2",
                        "placeholder": "Search",
                        "viewName": 'serviceName',
                        "filterName": 'serviceId',
                        items: serviceDetailsList.services//fix me
                    }
                }, {*/
                    "label": "ACTION",
                    "viewName": "button",
                }],
                rowOnClick: showShipment,
                data: []
            };
            const tableActions = new TableLiteFactory(manifestTable,
                {
                    serviceCallback: ManifestService.getManifests,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;
            const resetFilters = tableActions.resetFilters;

            function showShipment(data){
                var viewConfirmation = new ManifestViewShipmentFactory({
                    item: data
                });

                viewConfirmation.getInstance().result.then(function(result){});
            }

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {;

                    item.serviceProfileName = item.serviceProfile ? item.serviceProfile.name : 'All Service Profiles';
                    item.shipmentsCount = item.totalShipment || 0;
                    item.createdDateFormatted = $filter('bbaDate')(item.createdDate);
                    item.companyName = angular.getObjVal(item, 'office.company.name');
                    item.officeName = angular.getObjVal(item, 'office.name');
                    item.carrierProfileName = angular.getObjVal(item, 'carrierProfile.name') || angular.getObjVal(item, 'carrier.carrierName') + ' - All' ;
                    item.jobId = angular.getObjVal(item, 'job.jobId') || 'N/A';
                    item.button = {
                        type: 'button',
                        buttons: [{
                            text: 'Download',
                            class: 'btn btn-primary',
                            action: function () {
                                ManifestService.downloadManifest(item.id, data=>{
                                },err=>{
                                    console.log(err)
                                });
                            }
                        }]
                    };
                    item.href = '';
                    manifestTable.data.push(item);
                });
            };
            this.tableData = manifestTable;
        };
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/ManifestedShipmentTableService.js